// https://stackoverflow.com/a/5915122
export default array => array[Math.floor(Math.random() * array.length)];


// WEBPACK FOOTER //
// src/utils/getRandomItem.js